const RING_DELAYS = [0, 0.09, 0.18, 0.27, 0.36];

export default function HueTunnel({ hue }) {
  return (
    <div className="tunnel" style={{ "--h": hue }} aria-hidden="true" data-testid="hue-tunnel">
      {RING_DELAYS.map((d, i) => (
        <div key={i} className="tunnel-ring" style={{ animationDelay: `${d}s` }} />
      ))}
    </div>
  );
}
